import coreStore from './core-store'
import Axios from 'axios'

const remoteResource = 'cashflow/api/v1/cash-events';

const store = coreStore.queryStore(coreStore.createCoreStore('cashEvent', remoteResource));

store.state.cashEventsByOperation = {}

store.getters.cashEventsByOperation = (state) => (operationId) => state.cashEventsByOperation[operationId] ?? []

store.mutations.setCashEventsByOperation = function(state, {operationId, cashEvents}) {
    state.cashEventsByOperation[operationId] = cashEvents;
}

store.actions.loadCashEventsByOperation = function({commit}, {operationId}) {
    return Axios.get(`${remoteResource}/by-operation/${operationId}`)
        .then(
        res => {
            commit('setCashEventsByOperation', {operationId, cashEvents: res.data})
        }
    )
}

export default store;